import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { MQ } from '@css/constants'

export const DatePickerInputWrapper = styled('div')(css`
  position: relative;
`)

export const inputStyles = css`
  min-width: 275px;
  width: 100%;
  cursor: pointer;

  ${MQ.SMALL_SCREENS} {
    min-width: unset;
  }
`

export const calendarIconStyles = css`
  position: absolute;
  right: 18px;
  top: 16px;
  height: 24px;
  width: 24px;
  pointer-events: none;
`
